define('../app/fukit/behavior/show.modal.on.event.behavior',['require','exports','module','underscore','backbone','marionette','bluebird','backbone.radio','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Backbone = require('backbone'),
      Mn       = require('marionette'),
      Promise  = require('bluebird'),
      Radio    = require('backbone.radio'),
      UIKit    = require('uikit/uikit');

  var ShowModalOnEventBehavior = Mn.Behavior.extend({
    defaults: {
      // This method is called at the beginning of the onEvent method.  If preventOnEventHandler
      //  returns true, the rest of onEvent doesn't run.
      // The default allows onEvent to run always.
      preventOnEventHandler: function() {
        return false;
      },

      // name of modal to invoke
      modalName: null,

      // listen to this event
      eventName: 'press',

      // listen to this object as the source of the event
      eventSource: null,

      modalClass: UIKit.Modal2,

      // options to be passed to the modal constructor
      modalOptions: null,

      // function to execute when modal has started showing
      onModalShow: null,
      // function to execute when modal has finished showing
      onModalVisible: null,
      // function to execute when modal has started hiding
      onModalHide: null,
      // function to execute when modal has finished hiding
      onModalHidden: null,
      // function to execute when modal confirm button was pressed
      onModalConfirm: null,
      // function execute when the modal deny button was pressed
      onModalDeny: null,
    },

    initialize: function() {
      var eventSource = this.getOption('eventSource') || this.view;
      this.listenTo(eventSource, this.getOption('eventName'), this.onEvent);
    },

    onEvent: function() {
      var preventOnEventHandler = this.getOption('preventOnEventHandler');
      if (preventOnEventHandler.bind(this)()) {
        return;
      }
      Promise.resolve(Mn._getValue(this.getOption('modalName'), this))
        .bind(this)
        .then(function(modalName) {
          this.showModal(modalName);
        })
        .catch(function(err) {
          if (_.isFunction(this.getOption('onModalNameError'))) {
            this.getOption('onModalNameError').call(this, err);
          }

          throw err;
        });
    },

    showModal: function(modalName) {
      //prettier-ignore
      var self            = this,
          onModalShow     = this.getOption('onModalShow'),
          onModalVisible  = this.getOption('onModalVisible'),
          onModalHide     = this.getOption('onModalHide'),
          onModalHidden   = this.getOption('onModalHidden'),
          onModalConfirm  = this.getOption('onModalConfirm'),
          onModalDeny     = this.getOption('onModalDeny'),
          modalOptions    = Mn._getValue(this.getOption('modalOptions'), this),
          controller      = Radio.request('AppKit.controllerService', 'controller'),
          pageView        = controller ? controller.page : null,
          modalComponents = (pageView ? pageView.getOption('modals') : {}) || {},
          modalComponent  = Mn._getValue(modalComponents[modalName], pageView) || {};

      if (!modalComponent) {
        return;
      }

      if (modalOptions) {
        _.extend(modalComponent, modalOptions);
      }

      var modalView = pageView.buildComponent(
        _.extend({ type: this.getOption('modalClass'), name: modalName, visible: false }, modalComponent)
      );

      if (onModalShow) {
        this.listenTo(modalView, 'modal:show', onModalShow);
      }

      if (onModalVisible) {
        this.listenTo(modalView, 'modal:visible', onModalVisible);
      }

      if (onModalHide) {
        this.listenTo(modalView, 'modal:hide', onModalHide);
      }

      if (onModalHidden) {
        this.listenTo(modalView, 'modal:hidden', onModalHidden);
      }

      if (onModalConfirm) {
        this.listenTo(modalView, 'confirm', onModalConfirm);
      }

      if (onModalDeny) {
        this.listenTo(modalView, 'deny', onModalDeny);
      }

      _.defer(function() {
        modalView.visible = true;
      });
    },
  });

  module.exports = ShowModalOnEventBehavior;
});

